import React from 'react';
import styled from 'styled-components';

import Html from 'partials/Html';
import css from 'css';
import WP from 'WP';
import SmartLink from 'partials/SmartLink';
import Image from 'partials/Image';

const ContentWithSidebar = props => {
    const { data } = props;
    const imageClass = window.matchMedia("(max-width: 768px)").matches ? 'expandable image' : 'image';
    return (
        <ContentWrapper>
            <Sidebar>
                {data.acf.images && data.acf.images[0] &&
                    data.acf.images.map((imageItem, i) => {

                        const {height, width} = imageItem.image;
                        return (
                            <AsideImage key={i}>
                                {imageItem.image && <Image image={imageItem.image} className={imageClass} background ratio={height > width ? "783:1259" : "1259:783"} /> }
                                {imageItem.description && <div className="description">{imageItem.description}</div> }
                                {imageItem.credit.title && 
                                    <div className="credit">
                                        <span>{WP.trans.credit}</span>
                                        {imageItem.credit.url && <SmartLink to={imageItem.credit.url} >{imageItem.credit.title}</SmartLink> } 
                                        {!imageItem.credit.url && imageItem.credit.title } 
                                    </div>
                                }
                                
                            </AsideImage>
                        )
                    })
                }
            </Sidebar>
            <Main>
                {data.content && <Html className="content" content>{data.content.rendered}</Html>}

                {data.type !== 'projects' && data.type !== 'post' &&
                    <Author>
                        <span>{WP.trans.author}</span>
                        {data.acf.author || data.author_name}
                    </Author>
                }
                <RelatedLinksAndEmployees>
                    {data.acf.related_links &&
                        <div className="links">
                            <h6>{WP.trans.relevantLinks}</h6>
                            {data.acf.related_links[0] &&
                                <ul>
                                    {data.acf.related_links.map((item, i) => {
                                        return <li key={i}><SmartLink to={item.link.url} >{item.link.title}</SmartLink></li>
                                    })}
                                </ul>
                            }
                        </div>
                    }
                    {data.acf.employees && 
                        <div className="employees">
                            <h6>{WP.trans.employees}</h6>
                            {data.acf.employees[0] &&
                                <ul>
                                    {data.acf.employees.map(employee => {
                                        return (
                                            <li key={employee.ID}>
                                                {employee.meta.job_title && <span>{employee.meta.job_title[0]}</span> }
                                                {employee.post_title}
                                            </li>
                                        )
                                    })}
                                </ul>
                            }
                        </div>
                    }
                </RelatedLinksAndEmployees>
            </Main>
        </ContentWrapper>
    )
}

export default ContentWithSidebar;

const ContentWrapper = styled.div`
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top:80px;
    @media (max-width:768px) {
        padding-top:35px;
    }
`

const Sidebar = styled.aside`
    width:40%;
    @media (max-width:768px) {
        width:100%;
    }
`

const Main = styled.section`
    width: ${css.sizes.rightColumn};
    .content {
        margin-bottom:80px;
    }
    @media (max-width:768px) {
        width:100%;
        .content {
            margin-bottom:35px;
        }
    }
`

const Author  = styled.div`
    font-size:14px;
    margin-bottom:100px;
    span {
        display:block;
        color: #797979;  
    }
    @media (max-width:768px) {
        margin-bottom:35px;
    }
`

const RelatedLinksAndEmployees = styled.section`
    display:flex;
    flex-wrap: wrap;
    position:relative;
    margin-bottom: 80px;
    @media (max-width:768px) {
        margin-bottom: 10px;
    }
    h6 {
        font-size:24px;
        font-family: ${css.fonts.bg_bold};
        margin-bottom:20px;
    }
    .links {
        width:40%;
        margin-right: 5%;
        @media (max-width:768px) {
            width:100%;
            margin-right: 0;
            margin-bottom: 60px;
        }
        ul {
            li {
                margin-bottom:5px;
                a {
                    font-size:18px;
                }
            }
        }
    }
    .employees {
        width:40%;
        @media (max-width:768px) {
            width:100%;
        }
        ul {
            li {
                margin-bottom:40px;
                font-size:18px;
                span {
                    font-size:18px;
                    color: #797979;
                    display:block;
                    margin-bottom:5px;
                }
            }
        }
    }
`

const AsideImage = styled.figure`
    margin-bottom:45px;
    .description {
        color:#848484;
        font-size:14px;
        padding-top:25px;
    }
    .credit {
        padding-top:25px;
        font-size:14px;
        span {
            color:#848484;
            display:block;
        }
    }
    .image {
        @media (max-width:480px) {
            padding:0;
            height:190px;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/ContentWithSidebar.js